import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/nathan/Documents/GitHub/wmn-cms-docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "add-or-edit-a-main-event-page"
    }}>{`Add or Edit a main event page`}</h1>
    <p>{`Each roadwork or event needs to be manually added to the cms. `}</p>
    <pre><code parentName="pre" {...{}}>{`Navigate to this content location: West Midlands Network > Major roadworks and events
`}</code></pre>
    <p><img alt="Major roadworks and events" src={require("../../../../public/pages/major-works/main-hub/content-major-works.png")} /></p>
    <p>{`On the top right of the cms select the "Event Pages" tab. This will show a list of all roadworks and events.`}</p>
    <p><img alt="Major roadworks and events main pages" src={require("../../../../public/pages/major-works/event-hub/event-hub-content.png")} /></p>
    <p>{`Here you can edit an existing event or create a new one. `}</p>
    <h2 {...{
      "id": "add-an-event"
    }}>{`Add an event`}</h2>
    <h3 {...{
      "id": "create"
    }}>{`Create`}</h3>
    <p>{`Create a new event by clicking on the "Create Roadworks or Event Hub" button.`}</p>
    <p><img alt="Add new" src={require("../../../../public/pages/major-works/event-hub/event-hub-add-button.png")} /></p>
    <h4 {...{
      "id": "-required-details"
    }}>{`* Required details`}</h4>
    <p>{`The first required fields can be found on the "Page Copy" tab.`}</p>
    <ul>
      <li parentName="ul">{`Page name. This is the name of the roadwork or event.`}</li>
    </ul>
    <p><img alt="Create" src={require("../../../../public/pages/major-works/event-hub/event-hub-create-title.png")} /></p>
    <ul>
      <li parentName="ul">{`What's happening copy. This is the main summary of the roadwork or event. This summary will also appear on any sub pages of the event.`}</li>
    </ul>
    <p><img alt="Copy" src={require("../../../../public/pages/major-works/event-hub/event-hub-create-copy.png")} /></p>
    <p>{`The following required fields can be found on the "Roadworks or Event" tab.`}</p>
    <ul>
      <li parentName="ul">{`location. Select the location of the event from the dropdown list.`}</li>
      <li parentName="ul">{`Start date / time. Select the start date and time of the event.`}</li>
    </ul>
    <p><img alt="Location" src={require("../../../../public/pages/major-works/event-hub/event-hub-location.png")} /></p>
    <h3 {...{
      "id": "optional-details"
    }}>{`Optional Details`}</h3>
    <ul>
      <li parentName="ul">{`Image`}</li>
      <li parentName="ul">{`Copy`}</li>
      <li parentName="ul">{`Related content`}</li>
      <li parentName="ul">{`End date / time`}</li>
      <li parentName="ul">{`Ongoing`}</li>
      <li parentName="ul">{`Travel Tips. `}<a parentName="li" {...{
          "href": "/wmn-cms-docs/major-roadworks-and-events/add-travel-tips",
          "title": "Add Travel Tips"
        }}>{`Follow the Travel Tips documentation`}</a>{`.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      